import { motion } from "framer-motion";

export default function ChatMessage({ message }) {
  const isBot = message.sender === "bot";
  const isSystem = message.sender === "system";

  const formatTime = (ts) => {
    const d = new Date(ts);
    return d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
  };

  if (isSystem) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, ease: "easeOut" }}
        className="flex justify-center"
      >
        <div className="px-3 py-1.5 text-[11px] text-gray-500 bg-white/5 rounded-full border border-white/5">
          {message.text}
        </div>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 8, scale: 0.96 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className={`flex gap-2.5 ${isBot ? "justify-start" : "justify-end"}`}
    >
      {isBot && (
        <div className="w-7 h-7 rounded-full bg-gradient-to-br from-cyber-blue to-tech-green flex items-center justify-center shrink-0 mt-0.5">
          <svg viewBox="0 0 24 24" className="w-4 h-4 fill-black">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
          </svg>
        </div>
      )}

      <div
        className={`max-w-[82%] rounded-2xl px-4 py-2.5 text-sm leading-relaxed whitespace-pre-line ${
          isBot
            ? "bg-white/5 border border-white/10 text-gray-200 rounded-tl-sm"
            : "bg-cyber-blue text-black font-medium rounded-tr-sm"
        }`}
      >
        <p>{message.text}</p>
        <span
          className={`block text-[10px] mt-1.5 ${
            isBot ? "text-gray-500" : "text-black/50"
          }`}
        >
          {formatTime(message.timestamp)}
        </span>
      </div>
    </motion.div>
  );
}
